import React, { FC } from 'react'
import {useIntl} from 'react-intl';
import BaseKpi from './BaseKpi'
import {UserKpiModel} from '../../core/_models';

interface Props {
  data: UserKpiModel;
  isLoading: boolean;
}

export const UserKpi: FC<Props> = ({ data, isLoading }) => {
  const intl = useIntl();

  const format = (value: number) => intl.formatNumber(value)
  const moneyFormat = (value: number) =>
    intl.formatNumber(value, { style: 'currency', currency: 'EUR' });

  const rows = [{
    label: 'Visitors',
    curr: data.new.curr + data.returning.curr,
    prev: data.new.prev + data.returning.prev,
    icon: 'profile-user',
    format,
  }, {
    label: 'Registrations',
    curr: data.new.curr,
    prev: data.new.prev,
    icon: 'plus-square',
    format,
  }, {
    label: 'Retuning',
    curr: data.returning.curr,
    prev: data.returning.prev,
    icon: 'exit-right',
    format,
  }, {
    label: 'Active users',
    curr: data.active.curr,
    prev: data.active.prev,
    icon: 'chart-pie-simple',
    format,
  }, {
    label: 'Payout per user',
    curr: data.avgPayout.curr,
    prev: data.avgPayout.prev,
    icon: 'euro',
    format: moneyFormat,
  }]

  return (
    <BaseKpi
      color="info"
      title="Customers summary"
      label="Visitors"
      value={(data.returning.curr + data.new.curr).toString()}
      isLoading={isLoading}
      rows={rows}
    />
  )
}

